const quoteCarouselSwiper = document.querySelectorAll(
  ".js-quote-carousel .swiper"
);

if (quoteCarouselSwiper.length) {
  [].forEach.call(quoteCarouselSwiper, (carousel) => {
    const nrOfSlides = carousel.querySelectorAll(".swiper-slide").length;
    if (nrOfSlides === 1) {
      return;
    }

    new Swiper(carousel, {
      loop: false,
      effect: "fade",
      navigation: {
        nextEl: ".js-quote-carousel-next",
        prevEl: ".js-quote-carousel-prev",
      },
    });
  });
}
